const Type = Object.freeze({
  DEFAULT: 'DEFAULT',
  STATIC: 'STATIC',
  NEWSFLASH: 'NEWSFLASH'
})

export default Type
